import { BORDER_RADII, BUTTON_BORDER_RADII } from "../constants";
export const borderRadius = (size) => size && BORDER_RADII[size] ? BORDER_RADII[size] : BORDER_RADII.default;
export const buttonBorderRadius = (size) => size && BUTTON_BORDER_RADII[size] ? BUTTON_BORDER_RADII[size] : BUTTON_BORDER_RADII.default;
